module.exports = __webpack_public_path__ + "static/media/testimonial-hi1.6b5a8ab4.jpg";